import * as swcHelpers from '@swc/helpers';
import algoliaSearch from 'algoliasearch/lite';

function queryAlgolia(algoliaConfig, searchOptions) {
    return _queryAlgolia.apply(this, arguments);
}
function _queryAlgolia() {
    _queryAlgolia = swcHelpers.asyncToGenerator(function*(algoliaConfig, searchOptions) {
        const { apiKey , appId , indexName  } = algoliaConfig;
        if (!apiKey || !appId || !indexName) {
            console.error(`[queryAlgolia]: missing ApiKey: ${apiKey}, AppId:  ${appId} or indexName : ${indexName} `);
            return null;
        }
        /**
   * Initialize search client and index
   */ const client = algoliaSearch(appId, apiKey);
        const index = client.initIndex(indexName);
        if (!index) {
            console.error(`[queryAlgolia]: Cannot search on uninstantiated index.`);
            return null;
        }
        try {
            const result = yield index.search(searchOptions.query || '', swcHelpers.objectSpread({}, searchOptions));
            return result;
        } catch (e) {
            console.error(`[queryAlgolia]: Something went wrong searching Algolia.`);
            return null;
        }
    });
    return _queryAlgolia.apply(this, arguments);
}

export { queryAlgolia };
//# sourceMappingURL=query-algolia.js.map
